import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';
import Fade from '@smart-tv/components/fade/fade';
import { rootStore } from '../_stores/store-root';
import { uiStore } from '../_stores/store-ui';
import SheetActionsButtons from './sheet-actions-buttons';
import SheetActionsMeta from './sheet-actions-meta';
import SheetDescription from './sheet-description';
import SheetProgressBar from './sheet-progress-bar';
import SheetEpisodeSelector from './sheet-episode-selector';
import Typography from '@smart-tv/components/typography/typography';

export const ProgramSheetContent = observer(() => {
  const { sheet } = rootStore.sheetStore;

  const { toggles } = uiStore;

  if (!sheet) return null;

  const startTime = sheet.infoBlock?.startTime;
  const duration = sheet.infoBlock?.duration;
  const hasStartTime = typeof startTime === 'number';
  const hasDuration = typeof duration === 'number';

  React.useEffect(() => {
    const dateTimeInSeconds = new Date().getTime() / 1000;
    if (!hasStartTime || !hasDuration) return;
    const endTime = startTime + duration;
    if (dateTimeInSeconds < startTime) {
      rootStore.sheetStore.scheduleSheetRefreshAtTimeBoundary(startTime - dateTimeInSeconds);
    }
    if (startTime <= dateTimeInSeconds && dateTimeInSeconds < endTime) {
      rootStore.sheetStore.scheduleSheetRefreshAtTimeBoundary(endTime - dateTimeInSeconds);
    }
    // Sheet is needed to register if we close the player so we can recreate the delayed fetch if needed
  }, [hasStartTime, hasDuration, duration, startTime, sheet]);

  return (
    <div className={styles['program-sheet-content']}>
      <Fade in={!toggles.focusEpisodes}>
        <div className={styles['program-sheet-content__container']}>
          <div className={styles['program-sheet-content__left-column']}>
            <SheetActionsMeta />
            {sheet.providerAccessNeededText && (
              <Typography className={styles['program-sheet-content__missing-access']}>
                {sheet.providerAccessNeededText}
              </Typography>
            )}
            <SheetProgressBar />
            {sheet.buttons && <SheetActionsButtons />}
          </div>
          <div className={styles['program-sheet-content__right-column']}>
            <SheetDescription />
          </div>
        </div>
      </Fade>

      {!!sheet.totalNumberOfEpisodes && (
        <div className={styles['program-sheet-content__bottom-column']}>
          <SheetEpisodeSelector isFocused={toggles.focusEpisodes} />
        </div>
      )}
    </div>
  );
});

ProgramSheetContent.displayName = 'ProgramSheetContent';

export default ProgramSheetContent;
